// Typed wrappers of the Server Guardian endpoints (decision D35; apps/api/src/routes/guardian.ts). The API enforces every
// permission (run and actions: organization admin; status: maintainer+); the UI only avoids dead ends.
import type { GuardianAction, GuardianActionKind, GuardianRun, GuardianStatus } from "@maestros/contracts";
import { api } from "./client.ts";

export type { GuardianAction, GuardianActionKind, GuardianIncident, GuardianRun, GuardianStatus } from "@maestros/contracts";

export const getGuardianStatus = (signal?: AbortSignal) => api<GuardianStatus>("/guardian/status", signal ? { signal } : {});
export const runGuardian = () => api<{ run: GuardianRun }>("/guardian/run", { method: "POST", body: {} });
export const requestGuardianAction = (incidentId: string, action: GuardianActionKind) =>
  api<{ action: GuardianAction }>(`/guardian/incidents/${encodeURIComponent(incidentId)}/actions`, { method: "POST", body: { action } });
